export interface TrialRecord {
  id: string;
  dateRange: string;
  status: string;
  summary: string;
}

export const mockTrialRecords: TrialRecord[] = [
  {
    id: "1",
    dateRange: "10 Oct, 2025 - 11 Nov, 2025",
    status: "Ended",
    summary: "15 of 15 days",
  },
  {
    id: "2",
    dateRange: "01 Sep, 2025 - 30 Sep, 2025",
    status: "Ended",
    summary: "30 of 30 days",
  },
  {
    id: "3",
    dateRange: "15 Aug, 2025 - 29 Aug, 2025",
    status: "Ended",
    summary: "14 of 14 days",
  },
];


